import React from 'react';

import { ServiceTitanAppointment, ServiceTitanJob, TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';

import { Box } from '_lib/components/Box/Box';
import { Typography } from '_lib/components/Typography/Typography';
import { DateFormatEnum, DateUtils } from '_lib/utils/date.utils';

export interface ServiceTitanAppointmentDisplayProps {
  serviceTitanAppointment: ServiceTitanAppointment;
  job?: ServiceTitanJob;
  timezone: TimezoneAbbreviationEnum;
}

export const ServiceTitanAppointmentDisplay = (props: ServiceTitanAppointmentDisplayProps): React.ReactElement => {
  const { serviceTitanAppointment, job, timezone } = props;

  return (
    <Box>
      {job && <Typography text={`Job #${job.jobNo} - ${job.status}`} />}
      {!job && <Typography text={`No Job Number Found`} />}
      <Typography
        variant='body1Bold'
        text={DateUtils.format(serviceTitanAppointment.start, DateFormatEnum.DateTimeWeekday, {
          timezone,
          showTimezone: true
        })}
      />
    </Box>
  );
};
